import {styled} from "@mui/material/styles";
import Box from "@mui/material/Box";

export const TitleBox = styled(Box)(({theme}) => ({
    paddingBottom: "6vh",
}));